import { Dispatch, createContext } from "react";

type ContextElementsSelectedsContext = {
    selecteds: (string | number)[],
    setSelecteds: Dispatch<(string|number)[]>,
    selectedsAll: (data: any[], key: string) => void,
    isSelected: (element: any, key: string) => boolean,
    select: (element: any, key: string) => void,
    reset: VoidFunction
}

export const ElementsSelectedsContext = createContext<ContextElementsSelectedsContext>({} as ContextElementsSelectedsContext);